import React, { useEffect, useState } from 'react';
import {
    Routes,
    Route,
    useLocation
} from "react-router-dom";

import SubAdminUsers from './SubAdminUser.js';
import SubAdminSolarMeter from './SubAdminMeterSolar.js';
import SubAdminGridMeter from './SubAdminMeterGrid.js';
import SubAdminInverter from './SubAdminInverter.js';
import SubAdminPVLayout from './SubAdminPVLayout.js';
import SubAdminCommonSystem from './SubAdminCommonSystem';
import SubAdminEnvironment from './SubAdminEnvironment.js';
import SubAdminCenterTransfer from './SubAdminCenterTransfer.js';
import SubAdminAlarm from './SubAdminInverterAlarm.js';
import SubAdminNotify from './SubAdminNotify.js';
import SubAdminCCTV from './SubAdminCCTV.js';
import SubAdminIOT from './SubAdminIOT.js';
import SubAdminSystemRestore from './SubAdminSystemRestore.js';

import Minibar from '../../../components/navbar/Minibar';
import './MainAdmin.css';

function MainAdmin(props) {
    const location = useLocation();
    const [submenu_root, setSubmenu_root] = useState('Users Authentication');

    useEffect(() => {
        if (location.pathname.search("/users") > -1) {
            setSubmenu_root('Users Authentication')
        }
        if (location.pathname.search("/document") > -1) {
            setSubmenu_root('Document Attach')
        }
        if (location.pathname.search("/solarmeter") > -1) {
            setSubmenu_root('Solar Meter')
        }
        if (location.pathname.search("/gridmeter") > -1) {
            setSubmenu_root('Grid Meter')
        }
        if (location.pathname.search("/inverter") > -1) {
            setSubmenu_root('Inverter')
        }
        if (location.pathname.search("/pvlayout") > -1) {
            setSubmenu_root('PV Layout')
        }
        if (location.pathname.search("/environment") > -1) {
            setSubmenu_root('Environment')
        }
        if (location.pathname.search("/common") > -1) {
            setSubmenu_root('Common System')
        }
        if (location.pathname.search("/centertransfer") > -1) {
            setSubmenu_root('Center Transfer')
        }
        if (location.pathname.search("/inverteralarm") > -1) {
            setSubmenu_root('Inverter Alarm')
        }
        if (location.pathname.search("/notify") > -1) {
            setSubmenu_root('Alarm Notify')
        }
        if (location.pathname.search("/cctv") > -1) {
            setSubmenu_root('CCTV')
        }
        if (location.pathname.search("/iotmodule") > -1) {
            setSubmenu_root('IOT Module')
        }
        if (location.pathname.search("/restore") > -1) {
            setSubmenu_root('System Restore')
        }
    }, [location]);

    return (
        <section id="content" className="content">
            <Minibar
                main_root={"Administrative Tool"}
                submenu_root={submenu_root}
                systemtime={props.data_systemdatetime}
            />
            <div className="content__boxed d-md-flex h-100">
                <div className="content__wrap order-2 flex-fill min-w-0 hi-100 border-left">
                    <Routes>
                        <Route path="/users" element={<SubAdminUsers permitdata={props.permitdata} callback_backcenter={() => { props.callback_backcenter() }}></SubAdminUsers>} />
                        <Route path="/solarmeter" element={<SubAdminSolarMeter permitdata={props.permitdata} callback_backcenter={() => { props.callback_backcenter() }}></SubAdminSolarMeter >} />
                        <Route path="/gridmeter" element={<SubAdminGridMeter permitdata={props.permitdata} callback_backcenter={() => { props.callback_backcenter() }}></SubAdminGridMeter >} />
                        <Route path="/inverter" element={<SubAdminInverter permitdata={props.permitdata} data_uioption={props.data_uioption} callback_backcenter={() => { props.callback_backcenter() }}></SubAdminInverter>} />
                        <Route path="/pvlayout" element={<SubAdminPVLayout permitdata={props.permitdata} data_uioption={props.data_uioption} data_inverter={props.data_inverter} callback_backcenter={() => { props.callback_backcenter() }}></SubAdminPVLayout>} />
                        <Route path="/environment" element={<SubAdminEnvironment permitdata={props.permitdata} callback_backcenter={() => { props.callback_backcenter() }}></SubAdminEnvironment>} />
                        <Route path="/common" element={<SubAdminCommonSystem permitdata={props.permitdata} callback_backcenter={() => { props.callback_backcenter() }}></SubAdminCommonSystem>} />
                        <Route path="/centertransfer" element={<SubAdminCenterTransfer permitdata={props.permitdata} callback_backcenter={() => { props.callback_backcenter() }}></SubAdminCenterTransfer>} />
                        <Route path="/inverteralarm" element={<SubAdminAlarm permitdata={props.permitdata} callback_backcenter={() => { props.callback_backcenter() }}></SubAdminAlarm>} />
                        <Route path="/notify" element={<SubAdminNotify permitdata={props.permitdata} callback_backcenter={() => { props.callback_backcenter() }}></SubAdminNotify>} />
                        <Route path="/cctv" element={<SubAdminCCTV permitdata={props.permitdata} callback_backcenter={() => { props.callback_backcenter() }}></SubAdminCCTV>} />
                        <Route path="/iotmodule" element={<SubAdminIOT permitdata={props.permitdata} callback_backcenter={() => { props.callback_backcenter() }}></SubAdminIOT>} />
                        <Route path="/restore" element={<SubAdminSystemRestore permitdata={props.permitdata} callback_backcenter={() => { props.callback_backcenter() }}></SubAdminSystemRestore>} />
                    </Routes>
                </div>
            </div>
        </section>

    )
}
export default MainAdmin